const toLocalDateString = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export const getDefaultDateFrom = () => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return toLocalDateString(date);
};

export const getDefaultDateTo = () => toLocalDateString(new Date());

export const getDefaultDay = () => toLocalDateString(new Date());

const normalizeDateParam = (dateValue) => {
    if (!dateValue) return undefined;
    // Send just the date string (YYYY-MM-DD) without timezone conversion.
    // The backend interprets it in the venue's configured timezone.
    const parsed = new Date(`${dateValue}T00:00:00`);
    return Number.isNaN(parsed.getTime()) ? undefined : dateValue;
};

export const appendDateRangeParams = (params, dateConfig) => {
    dateConfig.forEach(([key, dateValue]) => {
        const value = normalizeDateParam(dateValue);
        if (value) params[key] = value;
    });
};
